import type { Moment } from 'moment-timezone';

const BOARDING_OFFER_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

export function isValidBoardingOfferDateString(date: string | undefined | null): boolean {
    const trimmed = date?.trim() ?? '';
    return trimmed.length > 0 && trimmed !== 'Invalid date' && BOARDING_OFFER_DATE_RE.test(trimmed);
}

export function getBoardingOfferDateRange(
    from: Moment | undefined | null,
    to: Moment | undefined | null
): { startDate: string; endDate: string } | null {
    if (from == null || to == null || !from.isValid() || !to.isValid()) {
        return null;
    }
    const startDate = from.format('YYYY-MM-DD');
    const endDate = to.format('YYYY-MM-DD');
    if (!isValidBoardingOfferDateString(startDate) || !isValidBoardingOfferDateString(endDate)) {
        return null;
    }
    return { startDate, endDate };
}

export function canFetchBoardingOffers(
    petId: number,
    from: Moment | undefined | null,
    to: Moment | undefined | null
): boolean {
    return Number.isFinite(petId) && petId > 0 && getBoardingOfferDateRange(from, to) != null;
}
